import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ModalRef, ModalModule, InputV2Module, ButtonV2Module } from '@schenck/rotec-components';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

export interface DrillTipModalData {
  crossEdgeFactor: number;
  drillTipAngle: number;
}

@Component({
  selector: 'rm-custom-drill-tip-modal',
  templateUrl: './custom-drill-tip-modal.component.html',
  styleUrls: ['./custom-drill-tip-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ModalModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective,
    InputV2Module,
    ButtonV2Module,
  ],
})
export class CustomDrillTipModalComponent {
  public modalRef = inject<ModalRef<DrillTipModalData>>(ModalRef);

  public width = '691px';
  public height = '480px';
  public title = 'Custom Drill Tip';

  public drillTipForm: UntypedFormGroup = new UntypedFormGroup({
    crossEdgeFactor: new UntypedFormControl(null, [
      Validators.required,
      Validators.min(0),
      Validators.max(100),
    ]),
    drillTipAngle: new UntypedFormControl(null, [
      Validators.required,
      Validators.min(0),
      Validators.max(180),
    ]),
  });

  constructor() {
    this.drillTipForm.patchValue(this.modalRef.data);
  }

  public save(): void {
    this.modalRef.emitAndClose(this.drillTipForm.getRawValue());
  }

  public cancel(): void {
    this.modalRef.close();
  }

  public onChangeForm(value: number, control: string): void {
    this.drillTipForm.get(control)?.setValue(value);
  }

  public get crossEdgeFactorValue(): number | undefined {
    if (this.drillTipForm.get('crossEdgeFactor').value) {
      return this.drillTipForm.get('crossEdgeFactor').value * 100;
    }
  }
}
